module.exports = __webpack_public_path__ + "img/vm2.cd12f354.webp";